import { memo } from "react";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectInspectionData } from "../../store/selectors/inspectionSelectors";
import { Card } from "primereact/card";
import { formatInspectionDate } from "../../utils/inspectionHelper";
import { InspectionStatusTag } from "./InspectionStatusTag";

export const InspectionGradeInfo = memo(() => {
    const inspection = useAppSelector(selectInspectionData);

    if (!inspection) {
        return null;
    }

    const labelAndValue = (label: string, value: any, fieldId: string, dataCyPrefix: string,  bold: boolean = false) => {
        return (
            <div className="flex align-items-center">
                <div className="col-5 details-label">
                    {label}
                </div>
                <div id={fieldId} data-cy={`${dataCyPrefix}-${fieldId}`} className={`col-7 details-value ${bold ? "font-semibold" : ""}`}>
                    {value}
                </div>
            </div>
        );
    };

    return (
        <Card>
            <div className="grid">
                <div className="md:col-4 col-12">
                    {labelAndValue("Vessel name", inspection.vesselName, "vessel-name", "vessel-name", true)}
                    {labelAndValue("IMO number", inspection.vesselImo, "imo-number", "imo-number")}
                    {labelAndValue("Vessel type", inspection.vesselType, "vessel-type", "vessel-type")}
                </div>
                <div className="md:col-4 col-12">
                    {labelAndValue("Inspection no", inspection.inspectionNumber, "inspection-no", "inspection-no", true)}
                    {labelAndValue("Status", <InspectionStatusTag status={inspection.status} />, "status", "status")}
                </div>
                <div className="md:col-4 col-12">
                    {labelAndValue("Inspection type", inspection.inspectionType, "inspection-type", "inspection-type", true)}
                    {labelAndValue("Location", `${inspection.port}, ${inspection.country}`, "location", "location")}
                    {labelAndValue("Date(s)", formatInspectionDate(inspection), "inspection-dates", "inspection-dates")}
                </div>
            </div>
        </Card>
    )
});